/**
 * Linhas de corte (crop marks) espelhando o SEM-TEXTO da Lambda.
 *
 * Cada etiqueta tem 8 segmentos (4 cantos × H/V) que saem ~27 pt da caixa.
 * Em slots vizinhos os ticks se encontram no vão e formam uma reta contínua.
 * O y_offset de −0,21 pt da coluna direita (legado) é ignorado só nos ticks,
 * para as retas horizontais não saírem tortas.
 *
 * Coordenadas em PDF (origem canto inferior esquerdo), iguais ao ReportLab.
 */
import { rgb, LineCapStyle } from "pdf-lib";
import { ARTWORK_LAYOUT } from "./labelAssets";
import { LABEL_SLOTS } from "./layout/constants";

const TICK_LEN = 27;
const INSET = 5.5;
const WHITE_WIDTH = 5;
const BLACK_WIDTH = 1;

/** y do slot esquerdo da mesma linha — deixa ticks H colineares. */
const cutMarkSlot = (slot, indexOnPage) => {
  const rowLeft = LABEL_SLOTS[Math.floor(indexOnPage / 2) * 2] || slot;
  return {
    x_offset: slot.x_offset || 0,
    y_offset: rowLeft.y_offset || 0,
  };
};

const slotBox = (slot) => {
  const left = ARTWORK_LAYOUT.x + (slot.x_offset || 0);
  const bottom = ARTWORK_LAYOUT.y + (slot.y_offset || 0);
  return {
    left,
    bottom,
    right: left + ARTWORK_LAYOUT.width,
    top: bottom + ARTWORK_LAYOUT.height,
  };
};

/** Segmentos H/V externos de um slot, já com origem PDF. */
const cutMarkSegmentsForSlot = (slot) => {
  const { left, bottom, right, top } = slotBox(slot);
  const yHi = top - INSET;
  const yLo = bottom + INSET;
  const xLeft = left + INSET;
  const xRight = right - INSET;

  return [
    { x1: left, y1: yHi, x2: left - TICK_LEN, y2: yHi },
    { x1: right, y1: yHi, x2: right + TICK_LEN, y2: yHi },
    { x1: left, y1: yLo, x2: left - TICK_LEN, y2: yLo },
    { x1: right, y1: yLo, x2: right + TICK_LEN, y2: yLo },
    { x1: xLeft, y1: top, x2: xLeft, y2: top + TICK_LEN },
    { x1: xRight, y1: top, x2: xRight, y2: top + TICK_LEN },
    { x1: xLeft, y1: bottom, x2: xLeft, y2: bottom - TICK_LEN },
    { x1: xRight, y1: bottom, x2: xRight, y2: bottom - TICK_LEN },
  ];
};

/**
 * Desenha ticks de corte para os slots ocupados (índice = posição na página).
 * Branco grosso por baixo + preto fino por cima (paridade com o SEM-TEXTO).
 */
const drawCutMarks = (page, slots) => {
  const segments = [];
  slots.forEach((slot, index) => {
    segments.push(...cutMarkSegmentsForSlot(cutMarkSlot(slot, index)));
  });

  const stroke = (color, thickness) => {
    for (const s of segments) {
      page.drawLine({
        start: { x: s.x1, y: s.y1 },
        end: { x: s.x2, y: s.y2 },
        thickness,
        color,
        lineCap: LineCapStyle.Round,
      });
    }
  };

  stroke(rgb(1, 1, 1), WHITE_WIDTH);
  stroke(rgb(0, 0, 0), BLACK_WIDTH);
};

export {
  TICK_LEN,
  INSET,
  cutMarkSlot,
  cutMarkSegmentsForSlot,
  drawCutMarks,
  slotBox,
};
